export const AUTH_SWITCH_COOKIE = '__auth_switch';
